import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from 'projects/internal/r1-component-library/src/lib/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PublicApiInterceptor } from 'projects/internal/r1-component-library/src/lib/interceptors';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app/app.routes';
import { provideRouter, RouterModule, withComponentInputBinding } from '@angular/router';
import { AppComponent } from './app/app.component';
import { LoginForm } from './app/models/login-form.model';
import { MetricsCard } from './app/models/metrics-card.model';
import { PatchAccountsForm } from './app/models/patch-accounts-form.model';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes, withComponentInputBinding()),
        importProvidersFrom(BrowserModule, ReactiveFormsModule, RouterModule),
        CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: PublicApiInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        LoginForm,
        MetricsCard,
        PatchAccountsForm,
    ],
}).catch(err => console.error(err));
